// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6382":"d80b5e6d","9628":"ffe73276"}[chunkId] + ".chunk.css";
};